<template>
  <div class="chat-v">
    <el-drawer :visible.sync="chatStatus" direction="rtl" :size="sreenSmall ? 497 : 1091" @close="closeChat">
      <div class="drawer-wrap">
        <div class="chat-title">
          <el-dropdown placement="bottom" trigger="click" @visible-change="changeAIvisible" :disabled="!reminderPro">
            <div class="dropdown-item">
              <span class="dropdown-item-text">{{ aiList[currentAI].name }}{{ currentAI==0?` (${this.useTotal} / ${this.sendTotal}) `:'' }}</span>
              <svg-icon v-if="reminderPro" class="arrow-down" name="position-arrow-down"></svg-icon>
            </div>
            <el-dropdown-menu slot="dropdown" class="custom-dropdown">
              <el-dropdown-item>
                <span @click="changeAI" class="xiaoyiAI">
                  {{ currentAI == 1 ? aiList[0].name : aiList[1].name }}
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="chart-title">
            <span @click="bigChat">
              <svg-icon name="small" v-if="sreenSmall" class="newIcon"></svg-icon>
              <svg-icon name="big" v-else class="newIcon"></svg-icon>
            </span>
            <span @click="closeChat">
              <svg-icon name="close" class="newIcon"></svg-icon>
            </span>
          </span>
        </div>
        <div v-show="currentAI == 0">
          <!-- <div class="header-style">
            <div class="buy" v-if="!reminderPro">
              {{ $i18.language('购买提问包，升至小易AIPro！') }}<span class="buy-now" @click="buyNow">{{ $i18.language('立即购买') }}</span>
            </div>
          </div> -->
          <div class="container">
            <div class="list-chat" :style="{ height: screenHeight }" id="list" ref="list">
              <ul>
                <div class="loading-m" v-if="moreLoadStatus">
                  <i class="el-icon-loading"></i>
                </div>
                <li v-for="(item, index) in msglist" :key="index">
                  <div :class="[item.me ? 'containerRight' : 'containerLeft']">
                    <span v-if="item.me">
                      <span v-if="userInfo.email" class="head-user">{{ userInfo.email.slice(0, 2).toUpperCase() }}</span>
                      <img class="head" v-else src="../../assets/origin.png" />
                    </span>
                    <span v-else><img class="head" src="../../assets/xiaoyi.png" /></span>
                    <div class="content">
                      <div class="text" v-if="item.me" >
                        {{ item.content }}
                      </div>
                      <div class="text" v-else >
                        <div v-if="item.history">{{ item.content }}</div>
                        <vue-typed-js v-else class="typed-cursor-d" :strings="[item.content]" :loop="false" :startDelay="300" :typeSpeed="100" :backSpeed="50" :contentType="'html'">
                          <span class="typing" @click="openLink"></span>
                        </vue-typed-js>
                        <div class="url-style" v-if="item.content.includes('</a>') && collectStauts">
                          <span :class="[clickIndex == index ? 'activeSpan' : '']" @click="isEffectiveUrl(item.content, index)"><svg-icon name="rightUrl" class="icon-url"></svg-icon>{{ $i18.language('网址正确') }}</span>
                          <span :class="[clickIndexError == index ? 'activeSpan' : '']" @click="errorIndex(item.content, index)"><svg-icon name="errorUrl" class="icon-url"></svg-icon>{{ $i18.language('网址错误') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="loading">
                  <div class="loading-show-style">
                    <img class="head" src="../../assets/xiaoyi.png" />
                    <i class="el-icon-loading el-icon-new"></i>
                  </div>
                </li>
              </ul>
            </div>
            <div class="bottom">
              <div class="input-send">
                <el-input max="140" maxlength="140" resize="none" :autosize="{ minRows: 1, maxRows: 5 }" v-model="sendContent" type="textarea" :readonly="loading" :placeholder="$i18.language('请输入聊天内容...')" class="inputTextArea" @keyup.enter.native="send"></el-input>
                <button class="send" @click="send" :disabled="loading">{{ $i18.language('发送') }}</button>
                <div class="say">
                  {{ $i18.language('小易是大语言模型下的人工智能客服，回复内容可能有误，仅供参考。如有任何异议，欢迎请提出') }}<span class="feedback" @click="feedback">{{ $i18.language('反馈') }}</span
                  >{{ $i18.language('，我们会尽力核实与优化。') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="currentAI == 1" :class="['GPT-box', sreenSmall?'':'index']">
          <history-session v-if="!sreenSmall" v-loading="loading" ref="historysession" @newDialog="newDialog" @changeActDialog="changeActDialog"></history-session>
          <sessionBox ref="sessionBox" :isRight.sync="isRight" @handleNewSession="handleNewSession"></sessionBox>
        </div>
      </div>
    </el-drawer>
    <!-- 问题反馈 -->
    <datachange-error-dialog ref="datachangeErrorDialog"></datachange-error-dialog>
    <!-- 支付表格 -->
    <chat-table ref="chatTable" @closeF="closeTable" @chatTableF="chatTableF"></chat-table>
  </div>
</template>
<script>
import datachangeErrorDialog from '../../views/Company/components/datachangeErrorDialog.vue'
import chatTable from '@/components/chatView/chatTable'
import sessionBox from '@/views/AIGPT/components/sessionBox';
import historySession from '@/views/AIGPT/components/historySession'
export default {
  name: 'chat',
  props: {
    collectStauts: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    datachangeErrorDialog,
    chatTable,
    sessionBox,
    historySession,
  },
  data() {
    return {
      screenHeight: null,
      sendContent: '',
      msglist: [],
      chatStatus: false,
      loading: false,
      sreenSmall: true,
      useTotal: 0, //当天使用量
      sendTotal: 0, //当天可发送总量
      pageNum: 1,
      moreLoad: true,
      moreLoadStatus: false,
      reminderPro: false,
      xiaoyiClick: false,
      clickIndex: 0,
      clickIndexError: 0,
      currentAI: 1, // 0是小易 1是GPT
      aiList: [
        {
          name: this.$i18.language('小易AI Pro'),
          value: 0,
        },
        {
          name: 'TradeGPT',
          value: 1,
        },
      ],
      isRight: 1,
    }
  },
  computed: {
    userInfo() {
      return localStorage.getItem('set_account_info') ? JSON.parse(localStorage.getItem('set_account_info')) : this.$store.getters.accountInfo
    },
  },
  watch: {
    // msglist(val) {
    //   this.$nextTick(() => {
    //     let ele = this.$refs.list
    //     if (ele.scrollHeight > ele.clientHeight) {
    //       ele.scrollTop = ele.scrollHeight
    //     }
    //   })
    // },
  },
  mounted() {
    this.screenHeight = document.documentElement.clientHeight - 103 + 'px'
  },
  methods: {
    // sessionBox的新会话问完 会刷新一次历史会话列表 并选中新会话的sessionKey
    handleNewSession(sessionKey) {
      this.$refs.historysession.getHistoryDialog(sessionKey)
    },
    newDialog() {
      this.$refs.sessionBox.newDialog()
    },
    changeActDialog(row) {
      this.$refs.sessionBox.changeActDialog(row)
    },
    initOpen() {
      // document.querySelector(".page-inner").style.overflow = 'hidden'
      this.getResponse(0, 1) // id为0 且 type为1 获取参数初始的可查询数量
      this.chatStatus = true
    },
    changeAIvisible(flag) {
    },
    changeAI() {
      this.currentAI = this.currentAI == 1 ? 0 : 1
      if (this.currentAI == 0) {
        this.getHistoryData()
      }
    },
    openLink(e) {
      if (e.target.dataset.tagname == 'tagA') {
        //判断当前域名是否有协议
        if (e.target.innerHTML.includes('http')) {
          window.open(e.target.innerHTML, '_blank')
        } else {
          let urlString = 'http://' + e.target.innerHTML
          window.open(urlString, '_blank')
        }
      }
    },
    chatTableF() {
      this.reminderPro = true
      this.getResponse(0, 1)
    },
    closeTable() {
      this.$refs.chatTable.dialogVisible = false
    },
    buyNow() {
      this.$refs.chatTable.dialogVisible = true
      this.$refs.chatTable.rechargeProducts()
    },
    isEffectiveUrl(item, index) {
      this.clickIndex = index
      this.clickIndexError = 0
      let url = item.split("blank'>")[1]

      let itemEndIdx = url.indexOf('</a>')
      //获取当前有效的  url
      if (this.collectStauts) {
        this.$emit('companyDetailChat', url.substring(0, itemEndIdx), true)
      }
    },
    errorIndex(item, index) {
      this.clickIndexError = index
      this.clickIndex = 0
      let url = item.split("blank'>")[1]

      let itemEndIdx = url.indexOf('</a>')
      //获取当前有效的  url
      if (this.collectStauts) {
        this.$emit('companyDetailChat', url.substring(0, itemEndIdx), false)
      }
    },
    handleScroll(e) {
      if (this.$refs.list.scrollTop == 0) {
        this.pageNum += 1
        this.getHistoryData(true)
      }
    },
    //获取小易历史数据
    getHistoryData(appendFlag) {
      this.$nextTick(() => {
        this.$refs.list.addEventListener('scroll', this.handleScroll)
      })
      if (!this.moreLoad) return
      this.moreLoadStatus = true
      this.$api.help.getHistoryPage({ pageIndex: this.pageNum, pageSize: 10 }).then((res) => {
        this.moreLoadStatus = false
        if (appendFlag) {
          // 是否拼接数据
          //  组装小易所需要的数据
          this.msglist = res.data.total > 0 ? [...this.changeMsglist(res.data.result), ...this.msglist] : this.msglist
          // 如果数据加载完
          if (!res.data.result.length) {
            this.moreLoad = false
          } else {
            this.$refs.list.scrollTop = 1
          }
        } else {
          this.msglist = res.data.total > 0 ? this.changeMsglist(res.data.result) : []
          this.LoaScrollTop()
        }
      })
    },
    // 定位top
    LoaScrollTop() {
      this.$nextTick(() => {
        let ele = this.$refs.list
        if (ele.scrollHeight > ele.clientHeight) {
          ele.scrollTop = ele.scrollHeight
        }
      })
    },
    // 过滤数组
    changeMsglist(arr) {
      let tempArr = []
      arr.forEach((item, index) => {
        if (item.replyContent) {
          tempArr.unshift(this.mergeArr(item, false))
        }
        tempArr.unshift(this.mergeArr(item, true))
      })
      return tempArr
    },
    mergeArr(item, status) {
      return {
        content: status ? item.sendContent : item.replyContent,
        history: true,
        time: item.replyDate,
        me: status,
      }
    },
    send(num) {
      if (!this.loading) {
        if (this.sendContent) {
          if (num && num == 1) {
            this.xiaoyiClick = true
          }
          this.msglist.push({
            content: this.sendContent,
            me: true,
          })
          this.getResponse()
        } else {
          if (num && num != 1) {
            this.$message({
              message: this.$i18.language('内容不能为空'),
              type: 'warning',
            })
          }
        }
      } else {
        return
      }
    },
    closeChat() {
      let dom = document.querySelector('.el-popup-parent--hidden')
      if (!dom) {
        document.body.style = ''
      }
      this.sendContent = ''
      this.chatStatus = false
      this.sreenSmall = true
      this.currentAI = 1
      this.isRight = 1
    },

    getResponse(id, type) {
      let params = {
        sendId: id ? id : 0,
        sendContent: this.sendContent,
      }
      this.$api.help.getChatMessage(params).then((res) => {
        if (res && res.code == 200) {
          this.reminderPro = res.data.reminderPro
          this.useTotal = res.data.sendTotal * 1 - res.data.useTotal * 1
          this.sendTotal = res.data.sendTotal
          if (res.data.replyContent) {
            // 判断当前字符串  是否包含  http  或者是  https
            if (this.collectStauts && this.xiaoyiClick) {
              // let pattern = /(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?/g
              let pattern = /(http:\/\/|https:\/\/|www\.)((\w|=|\?|\.|\/|&|-)+)/g
              let replacement = "<a href='javascript:void(0);' data-tagName='tagA' target='_blank'>$1$2</a>"
              res.data.replyContent = res.data.replyContent.replace(pattern, replacement)
            }
            this.msglist.push({
              content: res.data.replyContent,
              me: false,
            })
            this.loading = false
            this.xiaoyiClick = false
            this.sendContent = ''
          } else {
            if (!(type && type == 1)) {
              this.sendContent = ''
              this.loading = true
              setTimeout(() => {
                this.getResponse(res.data.sendId)
              }, 1000)
            }
          }
          // this.LoaScrollTop()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    bigChat() {
      this.sreenSmall = !this.sreenSmall
      this.$nextTick(() => { // 取消切换大小时候的全局滚动框
        let dom = document.querySelector('.el-popup-parent--hidden')
        if (dom) {
          document.body.style = 'padding-right: 17px;'
        } else {
          document.body.style = 'overflow: hidden;padding-right: 17px;'
        }
      })
      this.isRight = this.sreenSmall ? 1 : 2
    },
    feedback() {
      this.$refs.datachangeErrorDialog.Dataerrorcorrection = true
      this.closeChat()
    },
  },
}
</script>

<style lang="scss" scoped>
.lookText {
  // word-break: break-all;
  // white-space: pre-line;
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 14px;
  color: #1a173b;
  padding: 5px 0px;
  line-height: 19px;
}
.buy {
  width: 100%;
  text-align: center;
  font-size: 14px;
  height: 42px;
  line-height: 42px;
  color: #5e80ff;
  background: #eef2ff;
  span {
  }
}
.loading-m {
  width: 100%;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  color: $--color-primary-6;
  // margin-bottom: -10px;
}
.inputTextArea {
  /deep/.el-textarea__inner {
    // padding-top:13px;
    width: 85%;
    border: none;
    background: #ffffff;
    border-radius: 30px;
    padding-left: 18px;
    line-height: 25px;
  }
}
/deep/ .el-drawer__wrapper {
  z-index: 9999 !important;
  .el-drawer__header {
    display: none;
  }
}
.header-style {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #eeeeee;
  position: absolute;
  background: #fff;
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.proIconCont {
  margin-left: 5px;
  margin-right: 5px;
  width: 36px;
  height: 16px;
  display: inline-block;
  position: relative;
}
.proIcon {
  cursor: pointer;
  position: absolute;
  left: 0px;
  top: 3px;
}
.newIcon {
  cursor: pointer;
}
.chart-w {
  font-size: 14px;
  font-weight: 500;
  color: #1a173b;
}
.el-dropdown {
  position: absolute;
  top: 22px;
  left: 50%;
  transform: translateX(-50%);
}
.chart-title {
  position: absolute;
  float: right;
  top: 22px;
  right: 20px;
  > span:nth-child(1) {
    margin-right: 20px;
  }
}
.container {
  ul {
    padding: 0;
    margin: 0;
    padding-bottom: 40px;
  }
  li {
    list-style: none;
  }
  li:last-child {
    margin-bottom: 60px;
  }
  .list-chat {
    width: 100%;
    // height: 400px;
    overflow: auto;
    margin-bottom: 45px;
  }
  .bottom {
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #eeeeee;
  }
  .input-send {
    padding: 12px 24px;
    input {
      background: none;
      outline: none;
      border: none;
      width: 100%;
      height: 50px;
      border: none;
      background: #ffffff;
      border-radius: 30px;
      padding-left: 18px;
      line-height: 40px;
    }
    .say {
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #bcbcbc;
      line-height: 17px;
      margin-top: 10px;
      .feedback {
        color: $--color-primary-6;
        cursor: pointer;
      }
    }
    .send {
      width: 51px;
      height: 35px;
      border-radius: 75px 75px 75px 75px;
      opacity: 1;
      border: 1px solid #cccfd4;
      background: #fff;
      position: absolute;
      right: 23px;
      top: 12px;
      cursor: pointer;
    }
    /deep/.el-input__inner {
      width: 100%;
      height: 50px;
      border: none;
      background: #ffffff;
      border-radius: 30px;
      padding-left: 18px;
    }
    input:focus-visible {
      border: none;
    }
  }
}
.head,
.head-user {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #eee;
}
.head-user {
  // display: inline-block;
  color: #fff;
  background: #5e80ff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.containerLeft,
.containerRight {
  display: flex;
  align-items: flex-start;
  padding: 10px 15px;
  background-color: #f5f5f5;

  .content {
    margin-left: 10px;

    .text {
      font-size: 14px;
      color: #1a173b;
      padding: 5px 0px;
      line-height: 19px;
    }
    .img {
      width: 45px;
      height: 45px;
    }
  }
}
.containerLeft {
  .text {
    word-break: break-word;
    white-space: pre-wrap;
  }
}
.containerRight {
  background: #fff;
}
.loading-show-style {
  padding: 10px 15px;
  position: relative;
  .el-icon-new {
    position: absolute;
    top: 25px;
    left: 73px;
  }
}
/deep/ .typed-cursor-d .typed-cursor {
  display: none !important;
}
.url-style > span {
  padding: 4px 12px;
  width: 91px;
  height: 25px;
  border-radius: 60px 60px 60px 60px;
  opacity: 1;
  border: 1px solid #cccfd4;
  font-size: 12px;
  text-align: center;
  line-height: 25px;
  .icon-url {
    margin-right: 5px;
  }
  cursor: pointer;
  margin-right: 12px;
}
.url-style {
  margin-top: 12px;
}
.url-style > span:hover {
  border: 1px solid #5e80ff;
  color: #5e80ff;
  .svg-icon {
    color: #5e80ff;
    fill: currentColor;
  }
}
.activeSpan {
  border: 1px solid #5e80ff !important;
  color: #5e80ff;
  .svg-icon {
    color: #5e80ff;
    fill: currentColor;
  }
}
.buy-now {
  color: $--color-primary-6;
  cursor: pointer;
}
.dropdown-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  .dropdown-item-text {
    background-image:-webkit-linear-gradient(left, #BA53FC,#8491FF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .arrow-down {
    font-size: $--font-size-small;
    margin-left: 5px;
  }
}
.el-dropdown-menu {
  z-index: 10001 !important;
  /deep/ .el-dropdown-menu__item {
    &:hover {
      background: rgba(234, 85, 25, 0.1)!important;
      border-color: transparent!important;
      color: $--color-theme!important;
    }
  }
}
.drawer-wrap {
  height: calc(100% - 57px);
  .chat-title {
    padding: 28px 0;
    line-height: 15px;
    border-bottom: 1px solid #DEDEDE;
  }
  .GPT-box {
    height: 100%;
  }
  /deep/ .el-dialog__wrapper {
    background: #00000050;
  }
  .index {
    display: flex;
    overflow: hidden;
    height: 100%;
    /deep/ .historyDialog {
      padding: 15px;
      margin: 0;
      width: 293px;
      height: 100%;
      background-color: #fff;
      overflow-y: hidden;
      border-radius: 0;
      border-right: 1px solid #DEDEDE;
      box-sizing: border-box;
      .historyDialog-list {
        overflow-y: auto;
      }
    }
  }
}
.el-dropdown [disabled] {
  cursor: pointer !important;
}
.custom-dropdown {
  .el-dropdown-menu__item {
    padding: 0 !important;
  }
  .xiaoyiAI {
    display: block;
    width: 108px;
    text-align: center;
    &:hover {
      color: $--color-black;
      background: #eaecee;
    }
  }
}
</style>
